import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MaintenanceContractType } from '../../../../shared/interfaces';
import { AppSettings } from '../../../../shared/models';
import { AbstractBasicDataApiService } from '../../abstract-basic-data-api.service';


@Injectable({
  providedIn: 'root'
})
export class MaintenanceContractTypeApiService extends AbstractBasicDataApiService<MaintenanceContractType> {

  constructor(
    protected http: HttpClient
  ) {
    super(http, AppSettings.endpoints.basicinformation.vehicles.maintenanceContractType);
  }
}
